// src/hooks/reduxHooks.ts

import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../store/redux/types' // Import your store's specific AppDispatch type

export const useAppDispatch = () => useDispatch<AppDispatch>()
